module.exports = __webpack_public_path__ + "img/icon-pollution.fa751bef.png";